import axios from "axios";

export const getSchedule = (eventId) => {
  return axios
    .get(process.env.REACT_APP_FETCH_URL + `/get_schedules/${eventId}`);
};